import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import ResearchFieldViewList from 'features/ResearchField';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function ResearchFieldViewListPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="research_field">
            <ResearchFieldViewList />
          </Can>
          <Can not do="read" on="research_field">
            <h4 className="text-red-500">{t('permission.forbid.read.researchFieldList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default ResearchFieldViewListPage;
